import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[20px] pr-[0px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" }

import { ref } from 'vue'
    import contactsNavigation from '@/components/SubNavigations/TheContactsNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import useContactStore from '@/utils/useContactStore'
    import router from '@/router'
    import { Contact } from '@/model/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Contacts',
  setup(__props) {

    const {
        selectedContact,
        contacts,
        loading,
        fetchContacts,
        fetchContactsSearch,
        fetchContactsLimit,
        deleteContact,
        duplicateContact,
    } = useContactStore()

    const searchTerm = ref('')

    // Fetch offers on component mount
    async function fetchDataOnMounted() {
        await fetchContacts({ limit: 50, offset: 0, filter: '' })
    }

    fetchDataOnMounted()

    // functions defined and used here

    function search() {
        fetchContactsSearch({ limit: 50, offset: 0, filter: searchTerm.value })
    }

    // functions exported

    function selectContact(contact: Contact) {
        selectedContact.value = contact

        router.push('/contacts/edit/' + contact.contactId)
    }

    function createNewContact() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}

        router.push('/contacts/edit/0')
    }

    //breadcrumbs

    const breadcrumbs = [
        {
            title: 'Adressbuch',
            disabled: false,
            href: 'contacts',
        },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(contactsNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(FullButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewContact())),
          width: "100",
          title: " Neue Kontakt erstellen +",
          colour: "white",
          "data-cy": "create_contact_button"
        }),
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-left text-2xl font-light my-[3%]" }, [
          _createElementVNode("strong", null, "Liste aller Kontakte")
        ], -1)),
        _createVNode(_component_v_card, {
          class: "w-full mx-auto",
          color: "grey-lighten-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  loading: _unref(loading),
                  density: "comfortable",
                  type: "input",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (search())),
                  variant: "solo",
                  label: "Kontakt suchen",
                  title: "Person oder Organisation eingeben",
                  autofocus: "",
                  modelValue: searchTerm.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchTerm).value = $event)),
                  "append-inner-icon": "mdi-magnify",
                  "single-line": "",
                  "hide-details": "",
                  "data-cy": "search_contact_input"
                }, null, 8, ["loading", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ContactsTable, {
          load: _unref(fetchContactsLimit),
          duplicateMethod: _unref(duplicateContact),
          deleteMethod: _unref(deleteContact),
          selectMethod: selectContact,
          hasActions: true,
          contacts: _unref(contacts),
          contactsCount: 50
        }, null, 8, ["load", "duplicateMethod", "deleteMethod", "contacts"])
      ])
    ])
  ], 64))
}
}

})